// 在组件中使用
import api from '@/util/request'

export function category (data, params) {
  // 获取分类列表
  return api.post('/shop/Category/category', data, params)
}

export function announce_list (data, params) {
  // 获取资讯列表
  return api.post('/system/announce/announce_list', data, params)
}
export function announce_detail (data, params) {
  // 获取咨询详情
  return api.post('/system/announce/announce_detail', data, params)
}

export function getConfig (data, params) {
  // 获取配置
  return api.post('/system/basic/conf', data, params)
}
export function sendEmail (data, params) {
  // 发送邮件，type=2合作伙伴,type=1订阅即时通讯，type=3联系我们
  return api.post('/email/email/sendEmail2', data, params)
}





// 示例：GET请求
// api.get('/user/list', { page: 1, size: 10 })
//   .then(res => {
//     console.log('请求成功', res)
//   })
//   .catch(err => {
//     console.error('请求失败', err)
//   })

// // 示例：POST请求
// api.post('/user/add', { name: 'test', age: 20 })
//   .then(res => {
//     console.log('提交成功', res)
//   })
//   .catch(err => {
//     console.error('提交失败', err)
//   })